"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vinTransform = void 0;
var vinTransform = function (vin) {
    if (!vin) {
        return '';
    }
    var vinArray = vin.split('');
    return vinArray.slice(0, 5).concat(vinArray.slice(5).map(function () { return '*'; }));
};
exports.vinTransform = vinTransform;
